import request from '../utils/request'
import qs from 'qs'
export function bzRead(id){
    return request({
        url: 'compulsive/bzRead.do',
        method: 'post',
        data: qs.stringify({id: id})
    })
}